import { useEffect } from "react";
import { useQueryLoader } from "react-relay";

import { EventSignUpQueryString } from "../components/EventDetailCancelWindow";
import { EventDetailCancelWindowQuery } from "../components/__generated__/EventDetailCancelWindowQuery.graphql";

export const useGetEventSignUp = (eventSignUpId: string) => {
  const [eventSignUpQueryRef, loadEventSignUpQuery] =
    useQueryLoader<EventDetailCancelWindowQuery>(EventSignUpQueryString);

  useEffect(() => {
    if (eventSignUpId) {
      loadEventSignUpQuery(
        {
          eventSignUpId,
        },
        { fetchPolicy: "store-and-network" }
      );
    }
  }, [eventSignUpId, loadEventSignUpQuery]);

  return eventSignUpQueryRef;
};
